<div class="p-4 sm:p-8">
  @if (loading()) {
    <div class="flex items-center justify-center py-20">
      <span class="text-xs text-slate-400">Loading...</span>
    </div>
  } @else if (taxonomy()) {
    <!-- Header -->
    <div class="flex flex-col gap-4 mb-6 sm:mb-8">
      <!-- Top row: back + actions -->
      <div class="flex items-center justify-between gap-3">
        <button
          type="button"
          (click)="goBack()"
          class="w-8 h-8 flex items-center justify-center rounded-full border border-surface-300 hover:bg-surface-100 transition-colors cursor-pointer shrink-0"
        >
          <img src="/icons/arrow-left-icon.svg" class="w-4 h-4" alt="Back" />
        </button>

        <div class="flex items-center gap-2">
          <button
            type="button"
            (click)="showEditModal.set(true)"
            class="flex items-center gap-1.5 border border-surface-300 text-navy-700 hover:bg-surface-100 text-xs font-semibold px-3 py-2 sm:px-4 sm:py-2.5 rounded-xl transition-colors cursor-pointer"
          >
            <img src="/icons/edit-icon.svg" class="w-4 h-4" alt="" />
            <span class="hidden sm:inline">Edit</span>
          </button>
          <button
            type="button"
            (click)="showAddModal.set(true)"
            class="flex items-center gap-1.5 bg-accent-500 hover:opacity-90 text-white text-xs font-semibold px-3 py-2 sm:px-4 sm:py-2.5 rounded-xl transition-opacity cursor-pointer whitespace-nowrap"
          >
            <img src="/icons/plus-white-icon.svg" class="w-4 h-4" alt="" />
            Add Category
          </button>
        </div>
      </div>

      <!-- Title row -->
      <div>
        <div class="flex items-center gap-2 mb-1 flex-wrap">
          <h1 class="text-sm font-bold text-navy-900">{{ taxonomyName() }}</h1>
          <span
            class="inline-block px-2.5 py-0.5 rounded text-2xs font-semibold uppercase tracking-wide border"
            [ngClass]="
              type() === 'situation'
                ? 'border-accent-500 text-accent-500'
                : 'border-purple-50 bg-purple-10 text-purple-500'
            "
          >
            {{ type() === 'situation' ? 'Situation' : 'Response' }}
          </span>
        </div>
        <p class="text-xs text-slate-500">
          Managing operational category mappings and contextual settings.
        </p>
      </div>
    </div>

    <!-- Search -->
    <div class="flex items-center gap-3 mb-6">
      <div class="relative flex-1 max-w-xs">
        <img
          src="/icons/search-icon.svg"
          class="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 pointer-events-none"
          alt=""
        />
        <input
          type="text"
          placeholder="Filter by Name"
          [value]="searchQuery()"
          (input)="onSearchInput($event)"
          class="w-full pl-9 pr-4"
        />
      </div>
    </div>

    <!-- Categories table -->
    <div class="bg-white rounded-2xl border border-slate-100 shadow-card overflow-hidden">
      <app-data-table
        [columns]="columns()"
        [rows]="members()"
        [total]="totalMembers()"
        [pageSize]="pageSize"
        [page]="pageIndex() + 1"
        [loading]="loading()"
        [clickableRows]="true"
        (pageChange)="onPageChange($event)"
        (rowAction)="onMemberAction($event)"
      />
    </div>
  }
</div>

@if (editingMember()) {
  <app-edit-taxonomy-member-modal
    [member]="editingMember()!"
    [type]="type()"
    (closed)="editingMember.set(null)"
    (saved)="editingMember.set(null); loadMembers()"
    (removed)="editingMember.set(null); loadMembers()"
  />
}

@if (showEditModal() && taxonomy()) {
  <app-edit-taxonomy-modal
    [taxonomy]="taxonomy()!"
    [type]="type()"
    (closed)="showEditModal.set(false)"
    (saved)="showEditModal.set(false); loadTaxonomy()"
    (removed)="onTaxonomyRemoved()"
  />
}

@if (showAddModal()) {
  <app-add-taxonomy-category-modal
    [taxonomyId]="taxonomyId()"
    [type]="type()"
    [totalMembers]="totalMembers()"
    (closed)="showAddModal.set(false)"
    (saved)="showAddModal.set(false); loadMembers()"
  />
}

<ng-template #categoryNameTpl let-row>
  <div class="flex items-center gap-2.5">
    <img src="/icons/tag-icon.svg" alt="" class="w-4 h-4 shrink-0" />
    <span class="font-medium text-navy-900">{{ memberName(row) }}</span>
  </div>
</ng-template>

<ng-template #statusTpl let-row>
  <span
    class="inline-flex items-center px-2.5 py-0.5 rounded text-2xs font-semibold"
    [ngClass]="row.active ? 'bg-green-50 text-green-600' : 'bg-slate-100 text-slate-500'"
  >
    {{ row.active ? 'Active' : 'Inactive' }}
  </span>
</ng-template>
